export enum IpMode {
	DHCP = 'DHCP',
	STATIC = 'Static'
}
